import { addEventListener } from "../../../views/vendor/cookie-consent/js/util/dom";
class GTagLoader {
    constructor(measurementId) {
        this.measurementId = measurementId;
        this.gtagInitialized = false;
        this.defaultConsent = {
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            analytics_storage: "denied",
            functionality_storage: "granted",
            personalization_storage: "denied",
            security_storage: "granted",
        };

        // Bind the consent change handler
        addEventListener(
            "click",
            ".js-lcc-essentials",
            this.handleConsentChange.bind(this)
        );
        addEventListener(
            "click",
            ".js-lcc-accept",
            this.handleConsentChange.bind(this)
        );
        addEventListener(
            "click",
            ".js-lcc-settings-save",
            this.handleConsentChange.bind(this)
        );
    }

    checkCookieConsent(consentValue) {
        const cookieConsent = this.getCookie("__cookie_consent");
        if (
            !consentValue &&
            (
                cookieConsent === "true" ||
                Number(cookieConsent) === 3 ||
                Number(cookieConsent) === 2
            )
        ) {
            return true;
        }
        if (
            consentValue === "true" ||
            Number(consentValue) === 3 ||
            Number(consentValue) === 2
        ) {
            return true;
        }
        return false;
    }

    getCookie = function (name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
    };

    loadGTag() {
        if (!this.gtagInitialized) {
            window.dataLayer = window.dataLayer || [];
            window.gtag = window.gtag || function () {
                window.dataLayer.push(arguments);
            };

            gtag("consent", "default", this.defaultConsent);
            if (this.checkCookieConsent()) {
                gtag("consent", "update", this.getConsentPermissions());
            }

            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',this.measurementId);

            this.gtagInitialized = true;
        }
    }

    checkCookieConsent(consentValue) {
        if (
            !consentValue &&
            (this.getCookie("__cookie_consent") === "true" ||
                this.getCookie("__cookie_consent") === 3 ||
                this.getCookie("__cookie_consent") === 2)
        ) {
            return true;
        }
        if (
            consentValue === "true" ||
            consentValue === 1 ||
            consentValue === 2
        ) {
            return true;
        }
        return false;
    }

    getConsentPermissions = function () {
        const consent = this.getCookie("__cookie_consent");
        const consentData = { ...this.defaultConsent };
    
        if (consent === "true") {
            consentData.ad_storage = "granted";
            consentData.analytics_storage = "granted";
            consentData.personalization_storage = "granted";
            consentData.security_storage = "granted";
            consentData.ad_user_data = "granted";
            consentData.ad_personalization = "granted";
        } else if (Number(consent) === 2) {
            consentData.analytics_storage = "granted";
            consentData.personalization_storage = "granted";
        } else if (Number(consent) === 3) {
            consentData.ad_storage = "granted";
            consentData.ad_user_data = "granted";
            consentData.ad_personalization = "granted";
        }

        return consentData;
    };

    handleConsentChange() {
        this.loadGTag();
        const updatedConsent = this.getConsentPermissions();
        gtag("consent", "update", updatedConsent);
    }
}

export default GTagLoader;
